/* =====================================================
 Old fields for forms and modal forms
 ===================================================== */
(function ($) {
  var $bodyHtml = $("body, html");

  (function initContactForm() {
    var $switcher = $(".form-contact-us .switcher-radio-group"),
      $switcherItems = $switcher.find("li"),
      $switcherLinks = $switcher.find("a"),
      $select = $(".form-contact-us .your-user-type select");

    $switcherLinks.on("click", function (e) {
      e.preventDefault();
      $switcherItems.removeClass("active");
      $(this).closest($switcherItems).addClass("active");
      $select.find("option").attr("selected", false);
      $select
        .find("option")
        .eq($(this).closest($switcherItems).index() + 1)
        .attr("selected", "selected");
    });

    $(".form-contact-us form").on("submit", function () {
      if (!$switcherItems.filter(".active").length) {
        $switcher.addClass("switcher-radio-group_error");
      } else {
        $switcher.removeClass("switcher-radio-group_error");
      }
    });
  })();

  (function initScrollUp() {
    var $document = $(document),
      $window = $(window),
      $btnScrollTop = $(".btn-scroll-top"),
      bottomBannerClass = "btn-scroll-top_banner",
      offsetClass = "btn-scroll-top_offset",
      pageHasBottomBanner = $(".js-bottom-banner").length,
      scrollTop = 200;

    if (pageHasBottomBanner) {
      $btnScrollTop.addClass(bottomBannerClass);
    }

    $btnScrollTop.on("click", function () {
      $bodyHtml.animate(
        {
          scrollTop: 0,
        },
        400,
      );
    });

    $window.on("scroll", function () {
      if (
        $window.scrollTop() >= scrollTop &&
        $btnScrollTop.hasClass("invisibe")
      ) {
        $btnScrollTop.addClass("fadeInUp").removeClass("fadeOutDown invisibe");
      } else if (
        $window.scrollTop() < scrollTop &&
        !$btnScrollTop.hasClass("invisibe")
      ) {
        $btnScrollTop.addClass("fadeOutDown invisibe").removeClass("fadeInUp");
      }

      if ($window.scrollTop() + $window.height() > $document.height() - 100) {
        $btnScrollTop.addClass(offsetClass);
      } else {
        $btnScrollTop.removeClass(offsetClass);
      }
    });
  })();

  (function inputFocus() {
    let $formFieldContainer = jQuery(".form-field"),
      $formField = $formFieldContainer.find(".formField-js");

    $(".form-row_inline input[type=number]").keydown(function (event) {
      if (event.which === 189 || event.which === 109) {
        event.preventDefault();
      }
    });

    $formField.on("focusout", function () {
      let $currentField = jQuery(this);
      jQuery(this).parents(".form-field").removeClass("focus");
      if ($currentField.val().length > 0) {
        jQuery(this).parents(".form-field").addClass("not-empty");
      } else {
        jQuery(this).parents(".form-field").removeClass("not-empty");
      }
    });

    $formField.on("focus", function () {
      jQuery(this).parents(".form-field").addClass("focus");
    });

    $formField.each(function () {
      let $currentField = jQuery(this);
      if ($currentField.val().length > 0) {
        jQuery(this).parents(".form-field").addClass("not-empty");
        $currentField.on("change", function () {
          jQuery(this).parents(".form-field").addClass("not-empty");
        });
      }
    });
    let iwainterval = setInterval(function () {
      if (jQuery("input:-webkit-autofill")) {
        jQuery("input:-webkit-autofill").each(function () {
          jQuery(this).parents(".form-field").addClass("not-empty");
        });
      }
    }, 200);

    jQuery("select.form-control").on("select2:open", function (e) {
      jQuery(this).parents(".form-field").addClass("focus");
    });
    jQuery("select.form-control").on("select2:select", function (e) {
      jQuery(this)
        .parents(".form-field")
        .removeClass("focus")
        .addClass("not-empty");
    });
    jQuery(window).on("load", function () {
      clearInterval(iwainterval);
    });
  })();

  (function insertSiteUrlIntoForm() {
    $("[name=site-url]").each(function () {
      var url = window.location.href;
      var max = 250;
      var limitForPath = 247;

      if (url.length <= max) {
        $(this).val(url);
        return;
      }

      try {
        var u = new URL(url);
        var result = url;

        if (result.length > max) {
          result = u.origin + u.pathname;
        }

        if (result.length > max) {
          result = u.pathname;
        }
        if (result.length > max) {
          result = result.substring(0, limitForPath) + "...";
        }

        $(this).val(result);
      } catch (e) {
        $(this).val(url.substring(0, limitForPath) + "...");
      }
    });
  })();

})(jQuery);

/* =====================================================
 New Field Phone for forms and modal forms
 ===================================================== */
(function ($) {
  function setValAndCursor($input, val) {
    $input.val(val);
    if ($input[0]) {
      $input[0].setSelectionRange(val.length, val.length);
    }
    $input.trigger("input").trigger("change").trigger("wpcf7input");
  }

  function cleanPhone(value) {
    let val = value.replace(/[^\d+]/g, "");

    if (val.indexOf("+") > 0) {
      val = "+" + val.replace(/\+/g, "");
    }

    return val;
  }

  function formatOnBlur(input) {
    try {
      const phone = libphonenumber.parsePhoneNumber(input.value);

      if (phone && phone.isValid()) {
        input.value = phone.formatInternational();
      }
    } catch (e) {
    }
  }

  function handleInput($container, $input, $select) {
    $input.on("input", function () {
      const cleaned = cleanPhone(this.value);
      this.value = cleaned;

      if (!cleaned || cleaned === "+") {
        $container.removeClass("not-empty is-typing focus");
        $select.val(null).trigger("change");
      } else {
        $container.addClass("not-empty is-typing focus");
      }
    });

    $input.on("keydown", function (e) {
      const allowed = [
        "Backspace",
        "Delete",
        "ArrowLeft",
        "ArrowRight",
        "Tab",
        "Home",
        "End",
      ];

      if (/[\d+]/.test(e.key) || allowed.includes(e.key)) return;

      e.preventDefault();
    });

    $input.on("focus", function () {
      if (!this.value) this.value = "+";
      $container.addClass("focus");
    });

    $input.on("blur", function () {
      if (this.value === "+") this.value = "";

      formatOnBlur(this);

      if (!this.value.trim()) {
        $container.removeClass("not-empty focus is-typing");
      }
    });
  }

  function handleSelect($container, $input, $select) {
    $select.on("select2:select", function () {
      let code = this.value === "Other" ? "+" : this.value || "+";

      setValAndCursor($input, code);

      $container.addClass("not-empty is-typing focus");
      $input.focus();

      $container.removeClass("has-error");
      $input.removeClass("wpcf7-not-valid");
      $input.closest(".form-field").find(".wpcf7-not-valid-tip").fadeOut(100);
    });
  }

  function initForm($form) {
    const $container = $form.find("#unified-phone-container");
    if (!$container.length) return;

    const $input = $container.find("input[name='phone-number']");
    const $select = $container.find("select[name='country-code']");

    handleInput($container, $input, $select);
    handleSelect($container, $input, $select);
  }

  $(".form-name-eos-contact-us-form:not(.form-in-modal)").each(function () {
    initForm($(this));
  });

  $(".form-in-modal").each(function () {
    initForm($(this));
  });
})(jQuery);

// Delete (---) default select forms field
(function ($) {
  $(".formField-js-select").each(function () {
    var $select = $(this);
    var $parent = $select.closest(".form-field");

    $select
      .find("option")
      .filter(function () {
        return !this.value || this.value === "---";
      })
      .remove();
    $select.prepend('<option value="" selected="selected"></option>');

    $select.select2({
      placeholder: "",
      minimumResultsForSearch: Infinity,
      width: "100%",
    });

    function updateSelectState() {
      var val = $select.val();
      if (val && val !== "") {
        $parent.addClass("is-filled");
      } else {
        $parent.removeClass("is-filled");
        $parent.find(".select2-selection__rendered").empty();
      }
    }

    $select.on("change select2:select select2:unselect", updateSelectState);
    $select.on("select2:close", function () {
      setTimeout(updateSelectState, 10);
    });

    $select.val("").trigger("change.select2");
    updateSelectState();
  });
});

// Delete height fields Industry forms

jQuery(function ($) {

  $('select.industry-full-open').on('select2:open', function () {

    if (!window.matchMedia('(min-width: 1025px)').matches) return;

    setTimeout(function () {

      const $container = $('.select2-container--open');
      const $options = $container.find('.select2-results__options');

      if (!$container.length || !$options.length) return;

      const rect = $container[0].getBoundingClientRect();
      const viewportHeight = window.innerHeight;

      const spaceBelow = viewportHeight - rect.bottom;

      let maxHeight = spaceBelow - 2;

      maxHeight = Math.max(150, Math.min(maxHeight, 500));

      $options.css({
        'max-height': maxHeight + 'px',
        'overflow-y': 'auto'
      });

    }, 0);

  });

});